export default __webpack_public_path__ + "static/media/oneTimePayment.9e08570e.svg";